// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .after-cart {
  display: flex;

  align-items: center;
  top: 50px;
  margin: 10px 0;
  margin-left: 2.5rem;

  transition: all 0.3s ease-in-out;
} */

.after-cart {
  display: flex;
  align-items: center;
  justify-content: end;
  /* border: 1px solid #28af4b; */
  /* border-radius: 4px; */
}
.after-cart-no-leaf {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  /* border: 1px solid #28af4b; */
  /* border-radius: 4px; */
}

.button-after-cart-add {
  border: 1px solid #28af4b;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
  align-items: center;
}

.button-after-cart-add-no-leaf {
  border: 1px solid #28af4b;
  align-items: center;
  width: 100%;
  min-width: 150px;
}

.cart-counter-button {
  /* width: 40px; */
  /* height: 40px; */
  color: white;
  font-size: 26px;
  /* border-radius: 4px; */
  cursor: pointer;
  padding: 0 10px;
  border: none;
  background: transparent;
  transition: background-color 0.3s;
}

.increment-decrement-button {
  color: #28af4b;
  border: none;
  width: 50px;
}
.increment-decrement-button:hover {
  color: white;
  background-color: #28af4c77;
}

.decrement-button {
  color: #28af4b;
  border: none;
  border-top-left-radius: 20px;
}

.decrement-button:hover {
  color: white;
  background-color: #28af4c77;
}

.increment-button {
  color: #28af4b;
  border: none;
  border-bottom-right-radius: 20px;
}
.increment-button:hover {
  color: white;
  background-color: #28af4c77;
}

.cart-count {
  font-size: 16px;
  font-weight: bold;
  /* margin: 0 10px; */
  color: #28af4b;
  border-left: 0.5px solid #28af4c77;
  border-right: 0.5px solid #28af4c77;
  padding: 0 10px;
}

.add-to-cart-button {
  padding: 0px 20px;
  border: 1px solid #28af4b;
  background-color: #28af4b;
  color: aliceblue;
  font-family: Manrope;
  /* width: 100%; */
  /* border-radius: 4px; */
  height: 40px;
  cursor: pointer;
  transition: background-color 0.3s;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
}

.add-to-cart-button-no-leaf {
  padding: 0px 20px;
  border: 1px solid #28af4b;
  background-color: #28af4b;
  color: aliceblue;
  font-family: Manrope;
  width: 100%;
  border-radius: 4px;
  height: 40px;
  cursor: pointer;
  transition: background-color 0.3s;
  min-width: 150px;
  /* border-top-left-radius: 20px;
  border-bottom-right-radius: 20px; */
}

.add-to-cart-button:hover {
  color: #28af4b;
  background-color: white;
}

.font-size-add-btn {
  font-size: 26px;
}

/* .product-container.active .add-cart-button,
.product-container:hover .add-cart-button,
.product-container.active .after-cart,
.product-container:hover .after-cart {
  top: -30px;
} */
.b-items {
  margin: 100px 0 0 0;
  padding: 0;
}
.b-items__item {
  display: inline-block;
  /* border: 1px solid #eee; */
  width: 100%;
  position: relative;
  border-radius: 4px;
  /* margin: 0 12px 21px 12px; */
  text-align: end;
}

.b-items__item__img {
  border-radius: 4px 4px 0 0;
}

.b-items__item a {
  display: block;
  text-decoration: none;
  text-align: center;
}

.b-items__item a:hover {
  opacity: 0.8;
}

.b-items__item__title {
  display: block;
  font-size: 18px;
  margin-top: 9px;
  font-family: "Helvetica Neue";
  color: #95a5a6;
}

.b-items__item__add-to-cart {
  font-family: "Helvetica Neue";
  display: block;
  background: #16a085;
  color: #fff;
  margin-top: 9px;
  padding: 12px 0;
  border-radius: 0 0 4px 4px;
  border-bottom: 2px solid #0a9479;
}
.flying-img-container {
  z-index: 104; /* Ensure it's above your header */
  transition: all 0.8s ease;
}
`, "",{"version":3,"sources":["webpack://./src/components/fishCard/CartButtons/CartButtons.css"],"names":[],"mappings":"AAAA;;;;;;;;;GASG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,+BAA+B;EAC/B,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;AACA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,kCAAkC;EAClC,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,wBAAwB;EACxB,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB;qCACmC;AACrC;;AAEA;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;;GAKG;AACH;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,gCAAgC;AAClC;AACA;EACE,YAAY,EAAE,kCAAkC;EAChD,yBAAyB;AAC3B","sourcesContent":["/* .after-cart {\n  display: flex;\n\n  align-items: center;\n  top: 50px;\n  margin: 10px 0;\n  margin-left: 2.5rem;\n\n  transition: all 0.3s ease-in-out;\n} */\n\n.after-cart {\n  display: flex;\n  align-items: center;\n  justify-content: end;\n  /* border: 1px solid #28af4b; */\n  /* border-radius: 4px; */\n}\n.after-cart-no-leaf {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  /* border: 1px solid #28af4b; */\n  /* border-radius: 4px; */\n}\n\n.button-after-cart-add {\n  border: 1px solid #28af4b;\n  border-top-left-radius: 20px;\n  border-bottom-right-radius: 20px;\n  align-items: center;\n}\n\n.button-after-cart-add-no-leaf {\n  border: 1px solid #28af4b;\n  align-items: center;\n  width: 100%;\n  min-width: 150px;\n}\n\n.cart-counter-button {\n  /* width: 40px; */\n  /* height: 40px; */\n  color: white;\n  font-size: 26px;\n  /* border-radius: 4px; */\n  cursor: pointer;\n  padding: 0 10px;\n  border: none;\n  background: transparent;\n  transition: background-color 0.3s;\n}\n\n.increment-decrement-button {\n  color: #28af4b;\n  border: none;\n  width: 50px;\n}\n.increment-decrement-button:hover {\n  color: white;\n  background-color: #28af4c77;\n}\n\n.decrement-button {\n  color: #28af4b;\n  border: none;\n  border-top-left-radius: 20px;\n}\n\n.decrement-button:hover {\n  color: white;\n  background-color: #28af4c77;\n}\n\n.increment-button {\n  color: #28af4b;\n  border: none;\n  border-bottom-right-radius: 20px;\n}\n.increment-button:hover {\n  color: white;\n  background-color: #28af4c77;\n}\n\n.cart-count {\n  font-size: 16px;\n  font-weight: bold;\n  /* margin: 0 10px; */\n  color: #28af4b;\n  border-left: 0.5px solid #28af4c77;\n  border-right: 0.5px solid #28af4c77;\n  padding: 0 10px;\n}\n\n.add-to-cart-button {\n  padding: 0px 20px;\n  border: 1px solid #28af4b;\n  background-color: #28af4b;\n  color: aliceblue;\n  font-family: Manrope;\n  /* width: 100%; */\n  /* border-radius: 4px; */\n  height: 40px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n  border-top-left-radius: 20px;\n  border-bottom-right-radius: 20px;\n}\n\n.add-to-cart-button-no-leaf {\n  padding: 0px 20px;\n  border: 1px solid #28af4b;\n  background-color: #28af4b;\n  color: aliceblue;\n  font-family: Manrope;\n  width: 100%;\n  border-radius: 4px;\n  height: 40px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n  min-width: 150px;\n  /* border-top-left-radius: 20px;\n  border-bottom-right-radius: 20px; */\n}\n\n.add-to-cart-button:hover {\n  color: #28af4b;\n  background-color: white;\n}\n\n.font-size-add-btn {\n  font-size: 26px;\n}\n\n/* .product-container.active .add-cart-button,\n.product-container:hover .add-cart-button,\n.product-container.active .after-cart,\n.product-container:hover .after-cart {\n  top: -30px;\n} */\n.b-items {\n  margin: 100px 0 0 0;\n  padding: 0;\n}\n.b-items__item {\n  display: inline-block;\n  /* border: 1px solid #eee; */\n  width: 100%;\n  position: relative;\n  border-radius: 4px;\n  /* margin: 0 12px 21px 12px; */\n  text-align: end;\n}\n\n.b-items__item__img {\n  border-radius: 4px 4px 0 0;\n}\n\n.b-items__item a {\n  display: block;\n  text-decoration: none;\n  text-align: center;\n}\n\n.b-items__item a:hover {\n  opacity: 0.8;\n}\n\n.b-items__item__title {\n  display: block;\n  font-size: 18px;\n  margin-top: 9px;\n  font-family: \"Helvetica Neue\";\n  color: #95a5a6;\n}\n\n.b-items__item__add-to-cart {\n  font-family: \"Helvetica Neue\";\n  display: block;\n  background: #16a085;\n  color: #fff;\n  margin-top: 9px;\n  padding: 12px 0;\n  border-radius: 0 0 4px 4px;\n  border-bottom: 2px solid #0a9479;\n}\n.flying-img-container {\n  z-index: 104; /* Ensure it's above your header */\n  transition: all 0.8s ease;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
